import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="container d-flex justify-content-center align-items-center">
        <span>Hecho con 💗 por DGM -2021-</span>
      </div>
    </div>
  );
};

export default Footer;
